<section class="bg-half-170 bg-light d-table w-100" id="home"
         style="background: url('assets/banners/fe-rio-2.jpg') center center;">
    <div class="bg-overlay bg-overlay-white"></div>
    <div class="container">
        <div class="row mt-5 justify-content-center">
            <div class="col-lg-12 text-center">
                <div class="pages-heading">
                    <h4 class="title mb-0">{{ 'about.lasa' | translate }}</h4>
                </div>
            </div> <!--end col-->
        </div><!--end row-->

        <div class="position-breadcrumb">
            <nav aria-label="breadcrumb" class="d-inline-block">
                <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                    <li class="breadcrumb-item"><a routerLink="/">LASA 2025</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ 'about.lasa' | translate }}</li>
                </ul>
            </nav>
        </div>
    </div> <!--end container-->
</section>

<!-- Shape Start -->
<div class="position-relative">
  <div class="shape overflow-hidden text-color-white">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!--Shape End-->

<!-- About Start -->
<section class="section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
        <div class="position-relative">
          <img src="assets/lasaex1.png" class="rounded img-fluid mx-auto d-block" alt="">
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
        <div class="section-title ms-lg-4">
          <h4 class="title mb-4">{{ 'about.lasa' | translate }}</h4>
            <div [innerHTML]="'about.text1' | translate"></div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="position-relative">
                    <img src="assets/lasaex2.png" class="rounded img-fluid mx-auto d-block" alt="">
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="section-title ms-lg-4">
                    <h4 class="title mb-4">{{ 'about.mission' | translate }}</h4>
                    <div [innerHTML]="'about.text2' | translate"></div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
</section>

<!--end section-->
<!-- About End -->

<!-- Team Start -->
<!--<section class="section bg-light">-->
<!--  <div class="container">-->
<!--    <div class="row">-->
<!--      <div class="col-12 text-center">-->
<!--        <div class="section-title mb-4 pb-2">-->
<!--          <h4 class="title mb-4">Conheça nossa diretoria:</h4>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash;end col&ndash;&gt;-->
<!--    </div>-->
<!--    &lt;!&ndash;end row&ndash;&gt;-->

<!--    <div class="row align-content-center">-->
<!--      @for(data of memberData;track $index){-->
<!--      <div class="col-lg-3 col-md-6 mt-4 pt-2">-->
<!--        <div class="card team text-center bg-transparent border-0">-->
<!--          <div class="card-body p-0">-->
<!--            <div class="position-relative">-->
<!--              <img src="{{data.profile}}" class="img-fluid avatar avatar-ex-large rounded-circle" alt="">-->
<!--              &lt;!&ndash;end icon&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="content pt-3 pb-3">-->
<!--              <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">{{data.name}}</a></h5>-->
<!--              <small class="designation text-muted">{{data.designation}}</small>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    }-->
<!--      &lt;!&ndash;end row&ndash;&gt;-->
<!--    </div>-->
<!--    &lt;!&ndash;end container&ndash;&gt;-->


<!--    &lt;!&ndash;end container&ndash;&gt;-->
<!--  </div>-->
<!--</section>-->
<section class="section bg-cta" style="background: url('assets/images/copacabana3.jpg') center center;" id="cta">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title">
                    <h4 class="title title-dark text-white mb-4">{{'home.ctaThree.header' | translate }}</h4>
                    <p class="text-white-50 para-dark para-desc mx-auto">{{'home.ctaThree.description' | translate }}</p>
                    <a href="https://www.sympla.com.br/evento/5-encontro-anual-da-lasa/2818770" target="_blank"class="btn btn-danger btn-lg">{{'home.ctaThree.button' | translate }}
                    </a>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
    <!--end section-->
    <!-- Team End -->

    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top"
      [ngxScrollTo]="'#home'">
      <i-feather name="arrow-up" class="icons"></i-feather>
    </a>
    <!-- Back to top -->
